<template>
    <div class="stack">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5 border shadow-sm add-rounded">
                <h4 class="mb-3 font-weight-bolder kova-text">What Tech-stack requirement do you want your dev to have?</h4>            
                <a-select
                    mode="multiple" class="w-100 mt-4 mb-5" @change="handleChange" size="large" placeholder="What skills are required">
                    <a-select-option v-for="stack in stacks" :key="stack"
                    >{{stack}}</a-select-option
                    >
                </a-select>
                <div class="container-fluid px-0 px-md-4 mb-5">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right kova-text pt-3 mr-4">
                <span @click="skip">Skip <font-awesome-icon icon="step-forward"></font-awesome-icon></span>
            </div>
        </div>
        
        
 </div>
</template>
<script>
export default {
    name: 'stack',
    data(){
        return {
           stacks: [
                'PHP', 'Nodejs', 'Django', 'Flask', 'Laravel', 'Java', 'C#', 'C++', '.NET', 
                'Ruby', 'Scala', 'Perl', 'Symfony', 'Spring', 'JSF', 'Others'
                ] 
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push('specifications')
        },
        skip(){
            this.$router.push('specifications')
        }
    }
}
</script>
<style scoped>
.control-width{
    width: 600px;
}

@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>